import React, { useState, useEffect, useRef } from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import CssBaseline from "@mui/material/CssBaseline";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import "./tournamentDetails.css";

import { makeStyles } from "@mui/styles";
import { Button, Paper, Typography, Chip } from "@mui/material";
import MainMenu from "../../components/MainMenu";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import {
  clearPOTYTournament,
  getPOTYTournamentById,
  updatePlayerStatus,
} from "../../redux/actions/tournament-action";

import AddCircleIcon from "@mui/icons-material/AddCircle";
import AddIcon from "@mui/icons-material/Add";
import { createDraw, sendDraws } from "../../redux/actions/draw-action";
import { getFrontBackCourses } from "../../redux/actions/get-front-back-courses-action";
import { useNavigate, useParams } from "react-router-dom";
import IconButton from "@mui/material/IconButton";
import RemoveCircleRoundedIcon from "@mui/icons-material/RemoveCircleRounded";
import { styled } from "@mui/material/styles";
import {
  convertTime12To24,
  removeElementFromArray,
} from "../../helpers/Common";
import clsx from "clsx";
import { apiGet } from "../../utils/apiRequests";

import imgMedal1 from "../../assets/images/madel-1.png";
import imgMedal2 from "../../assets/images/madel-2.png";
import imgMedal3 from "../../assets/images/madel-3.png";
import imgMedal4 from "../../assets/images/madel-star.png";
import {
  clearLeaderboardProjectedScore,
  getLeaderboardProjectedScore,
} from "../../redux/actions/leaderboard-actions";
import DataTable from "react-data-table-component";

const useStyles = makeStyles(() => ({
  outlineInputBorder: {
    "& * > fieldset > legend": {
      display: "none",
    },
    "& > fieldset > legend > span": {
      display: "none",
    },
  },
  outlinedInputBox: {
    "& input[type='time' i]::-webkit-datetime-edit": {
      display: "none",
    },
    "& * > fieldset": {
      border: "none",
    },
    padding: 0,
  },
  stack1: {
    backgroundColor: "#C4C4C4",
    borderRadius: "5px",
  },
  stack2: {
    backgroundColor: "#2C633C",
    borderRadius: "5px",
  },
  tournamnetBox: {
    // padding:""
    // width: "138px",
    // textAlign: "center",
  },
  divider: {
    border: "1px solid black !important",
    height: "5px !important",
  },
  dividerBox: {
    backgroundColor: "black !important",
  },
  groupingBox: {
    backgroundColor: "#06623B",
  },
  createDrawsBtnContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  createDrawsBtnIcon: {
    backgroundColor: "#06623B",
  },
  createDrawsText: {
    fontWeight: "bolder  !important",
    marginLeft: "5px  !important",
    fontSize: "0.8em !important",
  },
  addGroupCard: {
    border: "2px dashed grey",
    display: "flex",
  },
  playerListHeading: {
    fontWeight: "700 !important",
  },
  confirmDrawBtn: {
    width: "10.5em !important",
    textTransform: "capitalize !important",
    backgroundColor: "#06623B !important",
    color: "#FFF !important",
  },
  teeColorBox: {
    fontWeight: "700 !important",
  },
  playerListText: {
    fontSize: "0.9em !important",
  },
  timeTextField: {
    borderRadius: "5px",
    padding: "0px !important",
    "& input[type='time' i]::-webkit-calendar-picker-indicator": {
      padding: "0px !important",
      margin: "0px !important",
      filter: "invert(1) !important",
    },
    "& input[type='date' i]::-webkit-calendar-picker-indicator": {
      padding: "0px !important",
      margin: "0px !important",
      filter: "invert(1) !important",
    },
    "& input[type='date' i]::-webkit-datetime-edit": {
      display: "none",
    },
  },
  clockInputAdornment: {
    backgroundColor: "#2C633C !important",
    color: "white",
    marginLeft: "4px !important",
    height: "65px !important",
    borderRadius: "5px",
    padding: "0px !important",
  },
  timeInput: {
    "& > div:first-child": {
      //   padding: 0,
    },
    "& > div > div:first-child": {},
    padding: "0 !important",
    // height: "35px",
  },
  scrollBarStyle: {
    "&::-webkit-scrollbar": {
      width: "5px !important",
    },
    // Track
    "&::-webkit-scrollbar-track": {
      background: "#C4C4C4 !important",
    },
    // Handle
    "&::-webkit-scrollbar-thumb": {
      background: "#06623B !important",
    },
    // Handle on Hover
    "&::-webkit-scrollbar-thumb:hover": {
      background: "#06623B !important",
    },
  },
  group_droppableArea: {
    border: "0px dashed #007e0038",
    height: "200px",
  },
  group_droppableAreaActive: {
    borderWidth: "2px",
  },
  listDroppableArea: {
    border: "0px dashed #007e0038",
    minHeight: "50px",
    height: "fit-content",
    // height: "320px"
  },
  listDroppableAreaActive: {
    borderWidth: "2px",
  },
  SaveBtn: {
    "&>div": {
      color: "WHITE",
      whiteSpace: "nowrap",
    },
  },
  SendDrawsBtn: {
    "&:hover": {
      background: "#C60808 !important",
      border: "0px !important",
      color: "White",
      "&>span": {
        //for ripple
        background: "#C60808",
        display: "none",
      },
    },
    "&>div": {
      whiteSpace: "nowrap",
    },
  },
  leaderboardBtn: {
    borderRadius: "5px !important",
    "&:hover": {
      backgroundColor: "#06623B !important",
    },
  },
  groupTypo: {
    fontSize: "15px !important",
    fontWeight: "600 !important",
    width: "40px",
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRight: "1px solid #ccc",
  },
  groupSelect: {
    "& *": {
      borderRadius: "0px !important",
      border: "0px !important",
    },
    "& > svg": {
      height: "100% !important",
      right: "0px !important",
      backgroundColor: "white",
      top: "0px",
    },
  },
}));

const token = localStorage.getItem("token");

function TournamentDetails(props) {
  const classes = useStyles();
  const { id } = useParams();

  const dispatch = useDispatch();

  //#region redux selector
  const tournamentName = useSelector(
    (state) => state?.getOneTournamentReducer?.data?.tournament_name
  );
  const tournamentDate = useSelector(
    (state) => state?.getOneTournamentReducer?.data?.tournament_date
  );
  const courseName = useSelector(
    (state) => state?.getOneTournamentReducer?.data?.course_name
  );
  const sponsorName = useSelector(
    (state) => state?.getOneTournamentReducer?.data?.sponsor_name
  );
  const sponsorCompany = useSelector(
    (state) => state?.getOneTournamentReducer?.data?.sponsor_company
  );

  const tournamentLeaderboardProjectedScore = useSelector(
    (state) => state?.getProjectedScoresByID?.data
  );
  const { loading } = useSelector((state) => state.getProjectedScoresByID);

  //   State
  const [leaderboardProjectedScoreData, setLeaderboardProjectedScoreData] =
    useState([]);
  const [pointsystem, setPointsystem] = useState([]);
  const [scoreMultiplyer, setScoreMultiplyer] = useState("");
  const [ranking, setRanking] = useState([]);
  const [points, setPoints] = useState([]);

  //#endregion

  //#region Components
  const HeaderItem = styled(Paper)(({ theme, noBG, head, rightBorder }) => ({
    backgroundColor: noBG ? "" : "#F2F2F2",
    // ...theme.typography.body1,
    padding: theme.spacing(0.55),
    textAlign: "center",
    color: theme.palette.text.secondary,
    borderRight: rightBorder ? " 1px solid grey" : "",
    border: head ? "0.5px solid #C4C4C4" : "none",
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  }));

  const GroupingButton = styled(Button)(({ theme }) => ({
    textTransform: "capitalize",
    color: "white !important",
    fontWeight: "bolder",
    backgroundColor: "#06623B",
  }));

  const HeaderItemComponent = (props) => {
    return (
      <HeaderItem elevation={0} square {...props}>
        <Typography
          textAlign="center"
          sx={{
            fontWeight: props.child ? "700" : "900",
            fontSize: "0.8em",
          }}
        >
          {props.text}
        </Typography>
      </HeaderItem>
    );
  };

  const filterRank = (id) => {
    if (ranking[id] === undefined) {
      return id + 1;
    } else {
      return ranking[id];
    }
  };

  const getPoints = (data, id) => {
    if (data.projected) {
      return parseFloat(points[id]).toFixed(2);
    } else {
      return "-";
    }
  };

  const rankingCal = (arr) => {
    let tempArr = [];

    // Remove Empty Score Players
    for (let a = 0; a < arr.length; a++) {
      if (arr[a].projected) {
        tempArr.push(arr[a]);
      }
    }

    // Sort Position
    let rank = tempArr.map(
      (x, y, z) => z.filter((w) => w.projected.net < x.projected.net).length + 1
    );

    // Rank Calculation
    let rankingT = [...rank];
    for (let a = 0; a < tempArr.length; a++) {
      if (a === 0) {
        if (rank[a] === rank[a + 1]) {
          rankingT[a] = `T${rank[a]}`;
        }
      }
      if (a > 0 && a < rank.length) {
        if (rank[a] === rank[a - 1] || rank[a] === rank[a + 1]) {
          rankingT[a] = `T${rank[a]}`;
        }
      }
      if (a === tempArr.length - 1) {
        if (rank[a] === rank[a - 1]) {
          rankingT[a] = `T${rank[a]}`;
        }
      }
    }

    // Points Calculation
    let points = [];
    for (let a = 0; a < tempArr.length; a++) {
      let counter = 0;
      let total = 0;
      let avg = 0;

      for (let b = 0; b < tempArr.length; b++) {
        if (tempArr[a].projected.net == tempArr[b].projected.net) {
          counter += 1;
          total +=
            (pointsystem[0]?.point_system[b].value / 100) *
            parseInt(scoreMultiplyer);
        }
      }

      avg = parseFloat(total) / counter;

      points.push(avg);
    }

    // Setting Values
    setPoints(points);
    setRanking(rankingT);
  };

  const customStyles = {
    expanderButton: {
      style: {
        "& > div": {
          display: "none",
        },
        "& > div > button": {
          display: "none !important",
        },
        display: "none !important",
      },
    },
    rows: {
      style: {
        "&:nth-child(even)": {
          backgroundColor: "#F2F2F2",
        },
        "& > div > div": {
          width: "100%",
          display: "flex",
          justifyContent: "center",
        },
        border: "none !important",
      },
    },
    headRow: {
      style: {
        border: "1px solid #C4C4C4",
        borderRadius: "10px",
      },
    },
  };

  const columns = [
    {
      name: <Typography variant="subtitle2"></Typography>,
      selector: (row, params) => {
        if (row.projected) {
          return (
            <div>
              {params === 0 ? (
                <img src={imgMedal1} alt="medal 1" />
              ) : params === 1 ? (
                <img src={imgMedal2} alt="medal 2" />
              ) : params === 2 ? (
                <img src={imgMedal3} alt="medal 3" />
              ) : params === 3 ? (
                <img src={imgMedal4} alt="medal 4" />
              ) : null}
            </div>
          );
        } else {
          return "-";
        }
      },
      width: "80px",
    },
    {
      name: (
        <Typography
          variant="subtitle2"
          sx={{
            width: "100%",
            textAlign: "center",
            fontWeight: 700,
            fontSize: "12px",
          }}
        >
          Rank
        </Typography>
      ),
      selector: (row, params) =>
        row?.projected ? (
          <Chip
            label={filterRank(params)}
            sx={{ width: "50px", fontWeight: 700 }}
            color="success"
            size="small"
          />
        ) : (
          "-"
        ),
      width: "80px",
      // sortable: true,
    },
    {
      name: (
        <Typography
          variant="subtitle2"
          sx={{
            width: "100%",
            textAlign: "center",
            fontWeight: 700,
            fontSize: "12px",
          }}
        >
          Player Name
        </Typography>
      ),
      width: "200px",
      selector: (row) => {
        let fullName = row?.first_name + " " + row?.last_name;
        return fullName.length > 20
          ? `${fullName.substring(0, 20)}...`
          : fullName;
      },
      sortable: ranking.length > 0 ? false : true,
    },
    {
      name: (
        <Typography
          variant="subtitle2"
          sx={{
            width: "100%",
            textAlign: "center",
            fontWeight: 700,
            fontSize: "12px",
          }}
        >
          Points
        </Typography>
      ),
      selector: (row, params) => getPoints(row, params),
    },
    {
      name: (
        <Typography
          variant="subtitle2"
          sx={{
            width: "100%",
            textAlign: "center",
            fontWeight: 700,
            fontSize: "12px",
          }}
        >
          Playing Handicap
        </Typography>
      ),
      selector: (row) => row?.playing_handicap,
      // sortable: true,
    },
    {
      name: (
        <Typography
          variant="subtitle2"
          sx={{
            width: "100%",
            textAlign: "center",
            fontWeight: 700,
            fontSize: "12px",
          }}
        >
          Gross Score
        </Typography>
      ),
      selector: (row) => {
        return row?.gross_score ? row?.gross_score : "-";
      },
      // sortable: true,
    },
    {
      name: (
        <Typography
          variant="subtitle2"
          sx={{
            width: "100%",
            textAlign: "center",
            fontWeight: 700,
            fontSize: "12px",
          }}
        >
          Net Score
        </Typography>
      ),
      selector: (row) => (row?.projected ? row?.projected.net : "-"),
      // sortable: true,
    },
    {
      name: (
        <Typography
          variant="subtitle2"
          sx={{
            width: "100%",
            textAlign: "center",
            fontWeight: 700,
            fontSize: "12px",
          }}
        >
          FIR
        </Typography>
      ),
      selector: (row) => (row?.fir === null ? "-" : row?.fir),
      width: "80px",
      // sortable: true,
    },
    {
      name: (
        <Typography
          variant="subtitle2"
          sx={{
            width: "100%",
            textAlign: "center",
            fontWeight: 700,
            fontSize: "12px",
          }}
        >
          GIR
        </Typography>
      ),
      width: "80px",
      selector: (row) => (row?.gir === null ? "-" : row?.gir),
      // sortable: true,
    },
    {
      name: (
        <Typography
          variant="subtitle2"
          sx={{
            width: "100%",
            textAlign: "center",
            fontWeight: 700,
            fontSize: "12px",
          }}
        >
          Putts
        </Typography>
      ),
      width: "80px",
      selector: (row) => (row?.putts ? row?.putts : "-"),
    },
  ];

  //#region UseEffects

  useEffect(() => {
    if (tournamentLeaderboardProjectedScore?.data?.length > 0) {
      let rankWiseArr = [...tournamentLeaderboardProjectedScore?.data];

      rankWiseArr.sort(
        (a, b) =>
          (a.projected != null ? a.projected.net : Infinity) -
          (b.projected != null ? b.projected.net : Infinity)
      );

      // Player Positioning
      for (let j = 0; j < rankWiseArr.length - 1; j++) {
        if (rankWiseArr[j].projected) {
          if (
            rankWiseArr[j]?.projected?.net ===
            rankWiseArr[j + 1]?.projected?.net
          ) {
            // LOGIC 1
            let sum1 = 0;
            let sum2 = 0;
            for (let a = 17; a >= 9; a--) {
              sum1 += parseInt(rankWiseArr[j].score_card[a].score);
              sum2 += parseInt(rankWiseArr[j + 1].score_card[a].score);
            }

            sum1 = sum1 - rankWiseArr[j].playing_handicap / 2;
            sum2 = sum2 - rankWiseArr[j + 1].playing_handicap / 2;

            if (sum1 === sum2) {
              // LOGIC 2
              sum1 = 0;
              sum2 = 0;

              for (let a = 17; a >= 12; a--) {
                sum1 += parseInt(rankWiseArr[j].score_card[a].score);
                sum2 += parseInt(rankWiseArr[j + 1].score_card[a].score);
              }

              sum1 = sum1 - rankWiseArr[j].playing_handicap / 3;
              sum2 = sum2 - rankWiseArr[j + 1].playing_handicap / 3;

              if (sum1 === sum2) {
                // LOGIC 3
                sum1 = 0;
                sum2 = 0;

                for (let a = 17; a >= 15; a--) {
                  sum1 += parseInt(rankWiseArr[j].score_card[a].score);
                  sum2 += parseInt(rankWiseArr[j + 1].score_card[a].score);
                }

                sum1 = sum1 - rankWiseArr[j].playing_handicap / 6;
                sum2 = sum2 - rankWiseArr[j + 1].playing_handicap / 6;

                if (sum1 === sum2) {
                  // LOGIC 4

                  sum1 = 0;
                  sum2 = 0;

                  for (let a = 0; a <= 8; a++) {
                    sum1 += parseInt(rankWiseArr[j].score_card[a].score);
                    sum2 += parseInt(rankWiseArr[j + 1].score_card[a].score);
                  }

                  sum1 = sum1 - rankWiseArr[j].playing_handicap / 2;
                  sum2 = sum2 - rankWiseArr[j + 1].playing_handicap / 2;

                  if (sum2 < sum1) {
                    let tempp = rankWiseArr[j];
                    rankWiseArr[j] = rankWiseArr[j + 1];
                    rankWiseArr[j + 1] = tempp;
                    j = -1;
                  }
                } else {
                  if (sum2 < sum1) {
                    let tempp = rankWiseArr[j];
                    rankWiseArr[j] = rankWiseArr[j + 1];
                    rankWiseArr[j + 1] = tempp;
                    j = -1;
                  }
                }
              } else {
                if (sum2 < sum1) {
                  let tempp = rankWiseArr[j];
                  rankWiseArr[j] = rankWiseArr[j + 1];
                  rankWiseArr[j + 1] = tempp;
                  j = -1;
                }
              }
            } else {
              if (sum2 < sum1) {
                let tempp = rankWiseArr[j];
                rankWiseArr[j] = rankWiseArr[j + 1];
                rankWiseArr[j + 1] = tempp;
                j = -1;
              }
            }
          } else if (
            rankWiseArr[j]?.projected?.net > rankWiseArr[j + 1]?.projected?.net
          ) {
            let tempp = rankWiseArr[j];
            rankWiseArr[j] = rankWiseArr[j + 1];
            rankWiseArr[j + 1] = tempp;
            j = -1;
          }
        }
      }

      rankingCal(rankWiseArr);
      setPointsystem(tournamentLeaderboardProjectedScore?.pointsystem);
      setScoreMultiplyer(
        tournamentLeaderboardProjectedScore?.points_multiplier
      );
      setLeaderboardProjectedScoreData(rankWiseArr);
    }
  }, [tournamentLeaderboardProjectedScore, pointsystem]);

  useEffect(() => {
    dispatch(getLeaderboardProjectedScore(id));
    return () => {
      dispatch(clearLeaderboardProjectedScore());
    };
  }, []);

  useEffect(() => {
    dispatch(getPOTYTournamentById(id));

    return () => {
      dispatch(clearPOTYTournament());
    };
  }, []);

  //#endregion

  return (
    <>
      <Grid container p={2}>
        <Grid item container={12}>
          <Grid item container p={2} xs={12} spacing={2}>
            <Grid item container xs={10}>
              <Grid item container xs={12}>
                <Grid item xs={3}>
                  <HeaderItemComponent text="Tournament" rightBorder head />
                </Grid>
                <Grid item xs={3}>
                  <HeaderItemComponent text="Course" rightBorder head />
                </Grid>
                <Grid item xs={3}>
                  <HeaderItemComponent text="Sponsor" rightBorder head />
                </Grid>
                <Grid item xs={3}>
                  <HeaderItemComponent text="Company" head />
                </Grid>
              </Grid>
              <Grid item container xs={12}>
                <Grid item xs={3}>
                  <HeaderItemComponent text={tournamentName} noBG child />
                </Grid>
                <Grid item xs={3}>
                  <HeaderItemComponent text={courseName} noBG child />
                </Grid>
                <Grid item xs={3}>
                  <HeaderItemComponent text={sponsorName} noBG child />
                </Grid>
                <Grid item xs={3}>
                  <HeaderItemComponent text={sponsorCompany} noBG child />
                </Grid>
              </Grid>
            </Grid>
            <Grid item container xs={2} rowSpacing={1}>
              <Grid item xs={12}>
                <GroupingButton
                  className={classes.leaderboardBtn}
                  color="primary"
                  fullWidth
                >
                  Leaderboard
                </GroupingButton>
              </Grid>
              <Grid item xs={12}></Grid>
            </Grid>
          </Grid>

          {loading ? (
            <Typography
              sx={{
                textAlign: "center",
                marginTop: "40px",
                width: "100%",
              }}
            >
              Loading...
            </Typography>
          ) : (
            <DataTable
              columns={columns}
              data={leaderboardProjectedScoreData}
              persistTableHead
              pagination={false}
              direction="vertical"
              expandableInheritConditionalStyles={true}
              customStyles={customStyles}
            />
          )}
        </Grid>
      </Grid>
    </>
  );
}

const TournamentDetailView = () => {
  return (
    <>
      <MainMenu>
        <Grid container>
          <Grid item xs={12}>
            <Paper elevation={3}>
              <TournamentDetails />
            </Paper>
          </Grid>
        </Grid>
      </MainMenu>
    </>
  );
};

export default TournamentDetailView;
